export default class FaqShowMore {
  constructor(element) {
    this.element = element
    this.button = element.querySelector('.faq-show-more-btn')
    this.accordion = element.querySelector('.accordion')
    this.visibleCount = 4

    if (this.button && this.accordion) {
      this.init()
    }
  }

  init() {
    const allItems = this.accordion.querySelectorAll('.accordion-item')

    // Hide items beyond the visible count and add class
    allItems.forEach((item, index) => {
      if (index >= this.visibleCount) {
        item.classList.add('s-faq__item-hidden')
      }
    })

    // Hide button if there are no hidden items
    const hiddenItems = this.accordion.querySelectorAll('.s-faq__item-hidden')
    if (hiddenItems.length === 0) {
      this.button.style.display = 'none'
      return
    }

    this.button.addEventListener('click', () => {
      this.showAllItems()
    })
  }

  showAllItems() {
    const hiddenItems = this.accordion.querySelectorAll('.s-faq__item-hidden')

    hiddenItems.forEach((item) => {
      item.classList.remove('s-faq__item-hidden')
    })

    // Hide the button after showing all items
    this.button.style.display = 'none'
  }
}
